import $ from 'jquery'

// Remount the sidebar if it unloaded itself.
function ensureSideBar() {
  if (!document.querySelector('[data-react-class="Glassfrog.components.SideBar"]').hasChildNodes())
    ReactRailsUJS.mountComponents('.app-side-bar')
}

// Allow ActionsController#new and ProjectsController#new modals to preserve as much common data as possible.
function swapWorkspaceModals(linkMatcher, formMatcher) {
  $(linkMatcher).on('click', (event) => {
    event.preventDefault()

    const baseUrl = $(event.target).attr('href')
    const commonFields = ['description', 'focus_icon', 'needed_by_date', 'note', 'parent_goal_or_target', 'person_id', 'projection_date', 'role_id_parent_role_id', 'status']
    const dataToSerialize = {}
    const formElement = $(formMatcher)[0]
    const formData = new FormData(formElement)
    const separator = (baseUrl.indexOf('?') > 0) ? '&' : '?'

    // Loop through all the fields present in this form.
    formData.entries().forEach(([key, value]) => {
      // Extract ['person_id'] from "project[person_id]"-formatted field names.
      const unscopedKey = key.match(/(?<=\[).+?(?=\])/)

      // If the field is common between Actions and Project AND contains data, then copy it.
      if (unscopedKey && unscopedKey.length > 0 && commonFields.includes(unscopedKey[0]) && value !== '')
        dataToSerialize[unscopedKey] = value
    })

    // Append copied data to the end of the original URL and fire it manually.
    const queryParams = new URLSearchParams(dataToSerialize)
    const url = `${baseUrl}${separator}${queryParams}`

    Turbo.visit(url, {frame: 'remote-modal'})
  })
}

export default {ensureSideBar, swapWorkspaceModals}
